import { GET_VENDOR_REQUEST, GET_VENDOR_SUCCESS, GET_VENDOR_FAIL,
    CREATE_VENDOR_REQUEST, CREATE_VENDOR_SUCCESS, CREATE_VENDOR_FAIL,
    UPDATE_VENDOR_REQUEST, UPDATE_VENDOR_SUCCESS, UPDATE_VENDOR_FAIL,
    DELETE_VENDOR_REQUEST, DELETE_VENDOR_SUCCESS, DELETE_VENDOR_FAIL } from "../types/vendorMasterTypes";
import Axios from 'axios';
import cogoToast from 'cogo-toast'; 
import APP_CONSTANT from '../../config/constants'

export const deleteVendor = (id) => async (dispatch) => {

    dispatch({ type: DELETE_VENDOR_REQUEST });

    try {

        const headerData = {
            "api_token": localStorage.getItem('apiToken'),
            "customerNumber": localStorage.getItem('customerNo'),
            "userId": localStorage.getItem('userId'),
        }

        const { data } = await Axios.delete(`${APP_CONSTANT.BASE_URL}masters/transporterMaster/${id}`,  {
            data: headerData,
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        });
        dispatch({ type: DELETE_VENDOR_SUCCESS, payload: data });
        window.location.reload()

            
    } catch (error) {
        if(error.response.data.status === 400){
            cogoToast.error(error.response.data.message, { position: 'top-right' })
        }
        dispatch({ type: DELETE_VENDOR_FAIL, payload: error.message })
    }
}

export const updateVendor = (updateVendorData, id) => async (dispatch) => {

    dispatch({ type: UPDATE_VENDOR_REQUEST });

    try {
    

        const { data } = await Axios.patch(`${APP_CONSTANT.BASE_URL}masters/transporterMaster/${id}`, updateVendorData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        });
        dispatch({ type: UPDATE_VENDOR_SUCCESS, payload: data });

        if(data.status === 0){
            cogoToast.error(data.message, { position: 'top-right' })
        } else {
            cogoToast.success(data.message, { position: 'top-right' }).then(() => {
                window.location.href = '/partner';
            })
        }
            
    } catch (error) {
        if(error.response.data.status === 400){
            cogoToast.error(error.response.data.message, { position: 'top-right' })
        }
        dispatch({ type: UPDATE_VENDOR_FAIL, payload: error.message })
    }
}

export const createVendor = (createVendorData) => async (dispatch) => {

    dispatch({ type: CREATE_VENDOR_REQUEST });

    try {

        const { data } = await Axios.put(`${APP_CONSTANT.BASE_URL}masters/transporterMaster`, createVendorData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        });
        dispatch({ type: CREATE_VENDOR_SUCCESS, payload: data });
        if(data.status === 200){
            cogoToast.success(data.message, { position: 'top-right' }).then(() => {
                window.location.href = '/partner';
            })
        } else {
            cogoToast.error(data.message, { position: 'top-right' })
        }
            
            
    } catch (error) {
        if(error.response.data.status === 400){
            cogoToast.error(error.response.data.message, { position: 'top-right' })
        }
        dispatch({ type: CREATE_VENDOR_FAIL, payload: error.message })
    }
}

export const getVendor = () => async (dispatch) => {

    dispatch({ type: GET_VENDOR_REQUEST });

    try {

        const headerData = {
            "api_token": localStorage.getItem('apiToken'),
            "customerNumber": localStorage.getItem('customerNo'),
            "userId": localStorage.getItem('userId'),
        }

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}masters/transporterMaster`,headerData , {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        });
        dispatch({ type: GET_VENDOR_SUCCESS, payload: data });
            
    } catch (error) {
        if(error.response.data.status === 400){
            cogoToast.error(error.response.data.message, { position: 'top-right' })
        }
        dispatch({ type: GET_VENDOR_FAIL, payload: error.message })
    }
}


export const getVendorById = (id) => async (dispatch) => {

    dispatch({ type: GET_VENDOR_REQUEST });

    try {
        let customerNumber = localStorage.getItem('customerNo')
        let userId = localStorage.getItem('userId')

        const { data } = await Axios.get(`${APP_CONSTANT.BASE_URL}masters/vendorDetails/${id}?customerNumber=${customerNumber}&userId=${userId}`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        });
        dispatch({ type: GET_VENDOR_SUCCESS, payload: data });
            
    } catch (error) {
        
        if(error.response.data.status === 400){
            cogoToast.error(error.response.data.message, { position: 'top-right' })
        }
        dispatch({ type: GET_VENDOR_FAIL, payload: error.message })

    }
}